import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const WebCartIcon: React.FC = () => {
  const [cartCount, setCartCount] = useState<number>(0);

  useEffect(() => {
    // Get web cart items count from sessionStorage (sum of quantities)
    const updateCartCount = () => {
      const savedCart = sessionStorage.getItem("webCartItems");
      if (savedCart) {
        try {
          const items = JSON.parse(savedCart);
          // Sum up all quantities
          const totalCount = items.reduce((sum: number, item: any) => {
            return sum + (item.quantity || 1);
          }, 0);
          setCartCount(totalCount);
        } catch (error) {
          setCartCount(0);
        }
      } else {
        setCartCount(0);
      }
    };

    // Initial count
    updateCartCount();

    // Listen for custom events (for same-tab updates)
    const handleWebCartUpdate = () => {
      updateCartCount();
    };

    window.addEventListener("webCartUpdated", handleWebCartUpdate);

    // Poll for changes (fallback for same-tab updates)
    const interval = setInterval(updateCartCount, 1000);

    return () => {
      window.removeEventListener("webCartUpdated", handleWebCartUpdate);
      clearInterval(interval);
    };
  }, []);

  return (
    <Link to="/services/cart" className="cart-icon-link">
      <div className="cart-icon-wrapper">
        <i className="ri-shopping-cart-line"></i>
        {cartCount > 0 && (
          <span className="cart-badge">{cartCount}</span>
        )}
      </div>
    </Link>
  );
};

export default WebCartIcon;

